export function requestNotificationPermission() {
    Notification.requestPermission();
}

export function showNotification(message: string) {
    // Let's check if the browser supports notifications
    if (!('Notification' in window)) {
        alert('This browser does not support desktop notification');
    }

    const notification = new Notification(message);
}
